import { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import LoadingScreen from '~/components/LoadingScreen';
import { RouteConfig } from '~/routes/routeConfig';
import useAuth from '../hooks/useAuth';

export const PublicGuard: React.FC<{ children: ReactNode }> = ({ children }) => {
  const { loading, loggedIn } = useAuth();

  if (loading) {
    return <LoadingScreen />;
  }

  if (loggedIn) {
    return <Navigate to={RouteConfig.AppRoot.buildLink()} />;
  }

  return <>{children}</>;
};
